import { render, staticRenderFns } from "./ProductTimeDiscountAdd.vue?vue&type=template&id=575dc7bd&"
import script from "./ProductTimeDiscountAdd.vue?vue&type=script&lang=js&"
export * from "./ProductTimeDiscountAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports